export default __webpack_public_path__ + "static/media/WhiteLogo.b22b34fd.svg";